import MenuSelect from './MenuSelect.view';

export default MenuSelect;